angular
    .module('MyApp')
    .service('AtendimentosService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {
      this.buscarAtendimentos = function(idCaso){
        let deferr = $q.defer();
         if (idCaso) {
            $resource(Configs.getApiServer() + '/npj/atendimentos-caso?idCaso=:idCaso',
                {}, { 'query': { method: 'GET', isArray: true } }).query({
                  idCaso
                }, function (response) {
                  deferr.resolve(response);

                }, function(){
                    deferr.reject();
                });
        } else {
            deferr.resolve(false);
        }
        return deferr.promise;
      }

      this.incluirAtendimento = function(atendimentoDTO) {
        let deferr = $q.defer();
        if (atendimentoDTO) {
          let defer = $q.defer();
          $resource(Configs.getApiServer() + "/npj/insere-atendimento", {}, {
                  query: {
                          method: 'POST',
                          cache: false
                      }
              })
              .query(atendimentoDTO, function(result) {
                  defer.resolve(result);
              }, function(err) {
                  defer.reject(err);
              });

          return defer.promise;
       } else {
           deferr.resolve(false);
       }
       return deferr.promise;
      }

}]);
